// @flow
import styled from "@emotion/styled";
import { ifProp } from "styled-tools";

import { maxChatWidth } from "src/styles/constants/size";
import * as colors from "src/styles/constants/colors";
import { fontSize } from "src/styles/constants/size";
import { NameOrEmail } from "src/components/user/styles";

export const ChatElement = styled.div`
  padding: 0 64px 0 24px;
  max-width: max(${maxChatWidth}, 100%);
`;

export const ChatCard = styled.div`
  width: 100%;
  padding: ${(props) =>
    `0 0 0 ${(!props.first ? 39 : 0) + (props.showSelect ? 12 : 0)}px`};
  display: flex;
  align-items: flex-start;
  gap: ${ifProp("first", "8px")};
`;

export const ChatMessage = styled(ChatElement)`
  display: flex;
  font-weight: normal;
  position: relative;
  width: 100%;
  ${(props) =>
    props.isMessageSelected &&
    `
    padding-top: 0.1rem;
    padding-bottom: 0.1rem;
    ::before {
      content: "";
      position: absolute;
      inset: 0;
      background: #b8bfcc4d;
      pointer-events: none;
  }`}
`;

export const MenuIcon = styled.div`
  position: absolute;
  right: 0;
  top: 0;
`;

export const FlexSpacer = styled.div`
  flex: 1;
`;

export const UserInfo = styled.div`
  display: inline-flex;
  > div > div {
    width: 36px;
    height: 36px;
    border-radius: 0.5em;
  }
`;

export const TimestampContainer = styled.div`
  display: flex;
  gap: 4px;
  align-items: baseline;
  flex-shrink: 0;
  height: 100%;
`;

export const ForwardedMessage = styled.div`
  background: ${ifProp(
    "isCurrentUser",
    colors.currentUserHighlight,
    colors.grey0,
  )};
  padding: 0.75rem;
  border-radius: 0.2em;
`;

export const FileInfo = styled.div`
  align-items: center;
  > svg {
    margin-left: -0.3em;
  }
  > div:nth-of-type(2) {
    margin-left: 0.3em !important;
  }
`;

export const NewMenu = styled.div`
  position: absolute;
  right: 20px;
  top: -15px;
  display: flex;
  svg {
    cursor: pointer;
  }
`;

export const MenuOption = styled.div`
  padding: 8px 4px;
  border-radius: 3px;
  margin-left: 3px;
  border: solid 1px ${colors.grey3};
  background-color: ${colors.brightLight};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Reply = styled(MenuOption)`
  position: relative;
  height: 30px;
  width: 30px;
  padding: 0px;
  top: -2px;
`;
export const Forward = styled(MenuOption)`
  position: relative;
  height: 30px;
  width: 30px;
  padding: 0px;
  top: -2px;
`;

export const Pin = styled(MenuOption)`
  padding: 3px 2px 4px 3px;
  height: 30px;
  width: 30px;
  position: relative;
  top: -2px;
`;

export const Start = styled(MenuOption)`
  color: ${colors.active};
  font-size: ${fontSize.small};
  position: relative;
  top: -2px;
  cursor: pointer;
  height: 30px;
`;

export const FileDownload = styled(MenuOption)`
  position: absolute;
  top: -2px;
  right: 147px;
  cursor: pointer;
  height: 30px;
  padding: 0 0.6em;
  > a {
    display: flex;
    > span {
      margin-left: 0.3em;
      color: ${colors.primary};
    }
  }
`;

export const Submenu = styled.div`
  background: transparent;
  border: none;
  position: absolute;
  top: 10px;
  right: -4px;
`;

export const Delete = styled(MenuOption)`
  height: 30px;
  width: 30px;
  position: relative;
  top: -2px;
  cursor: pointer;
  > img {
    height: 15px;
  }
`;

export const ForwardedInfoText = styled.div`
  display: inline-flex;
  color: ${colors.secondary};
  white-space: nowrap;
  > svg {
    flex: initial important!;
  }
`;

export const ForwardedContainer = styled.div`
  opacity: 1 !important;
  display: inline-flex;
  align-items: center;
  margin: 0.5rem 0 0.4rem 0;
  overflow: hidden;
  width: 100%;
  > div:last-child > a {
    display: flex;
    align-items: center;
    > span {
      white-space: nowrap;
      overflow-x: hidden;
      text-overflow: ellipsis;
      max-width: ${(props) =>
        props.width >= 350 ? "300px" : "100px"}!important;
      display: inline-block;
      margin-right: 2em;
    }
  }
`;

export const SelectCircle = styled.span`
  height: 20px;
  width: 20px;
  cursor: pointer;
  ${(props) =>
    props.disabled &&
    `
    /* Hide the checkbox if the notification can't be selected */
    visibility: hidden;
    `}
`;

export const UnhideOption = styled.span`
  color: ${colors.active};
  font-weight: bold;
  font-style: initial;
  margin-left: 1.6em;
  cursor: pointer;
`;

export const MessageNotchContainer = styled.div`
  position: absolute;
  left: -16.5px;
  top: -0.3px;
`;

export const ReplyMessageContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 8px;
  background: ${colors.grey0};
  padding: 1rem;
  border-radius: 0.2em;
  font-size: ${fontSize.base};
`;

export const ReplyMessageContent = styled.div`
  font-weight: initial;
  font-size: ${fontSize.base};
`;

export const CloseIcon = styled.div`
  position: absolute;
  right: 22px;
  height: 100%;
  top: 0px;
  display: flex;
  align-items: center;
`;

export const EmailReply = styled.div`
  > div {
    background: initial;
  }
`;

export const MessageHeader = styled.div`
  display: flex;
  gap: ${(props) => props.gap ?? "1rem"};
  justify-content: space-between;
  align-items: baseline;
  color: ${colors.grey39};
  font-size: ${fontSize.large};
`;

export const GenericNotification = styled(ChatElement)`
  display: flex;
`;

export const MessageCard = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: ${fontSize.large};
  overflow: ${(props) => props.overflow ?? "hidden"};
  max-width: 100%;
  ${(props) => props.width && `width: ${props.width};`}
  padding: 8px;
  gap: ${(props) => (props.isMessage ? (props.first ? "2px" : "0") : "8px")};
  background: ${(props) =>
    props.isChecklistNotification ? colors.grey41 : colors.brightLight};
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1);
  border-radius: ${(props) => (props.first ? "0 0.5em 0.5em 0.5em" : "0.5em")};
`;

export const DeletedMessageCard = styled(MessageCard)`
  display: inline-flex;
  flex-direction: row;
  align-items: baseline;
  gap: 1rem;
  > div {
    bottom: 1em; /* align timestamp for deleted message */
  }
`;

export const NotificationNameOrEmail = styled(NameOrEmail)`
  overflow: initial;
  text-overflow: initial;
  font-weight: ${(props) => (props.noBold ? "normal" : "bold")};
  font-size: ${(props) => (props.small ? fontSize.base : fontSize.large)};
`;
